{
    "CX_Record_Licences_None": "Nenhum",
    "CX_Record_Licences_CXRRecord": "Registro de radiografia de tórax",
    "CX_Record_Licences_CXRUser": "Usuário de CXR",
    "CX_Record_Licences_CXRManager": "Gerente de CXR",
    "CX_Record_Device_Or_Agent_Error": "É necessário um agente ou dispositivo para uma assinatura {}",
    "NAME": "Idioma do registro CX"
}